import React from 'react'
import { createRoot } from 'react-dom/client'
import { Chart as ChartJS } from 'chart.js'
import App from './App'
import './index.css'

// Configure Chart.js global defaults to use Montserrat font
ChartJS.defaults.font.family = '\'Montserrat\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', sans-serif'

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

const root = createRoot(container)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
